export default __webpack_public_path__ + "static/media/gallery-wip-3d-print_00.9d6c4ee6.jpg";